import React, { ReactNode } from "react";
import { If } from "@/components/custom/condition";
import { Info } from "lucide-react";
interface Props {
  className?: string;
  message: ReactNode;
  messageClass?: string;
  icon?: string;
  iconClass?: string;
}

export function Alert({
  iconClass = "text-error",
  className = "",
  icon = "",
  message = "",
  messageClass = "",
}: Props) {
  return (
    <div
      className={`min-h-12 w-full flex items-center p-3 mb-8 rounded-lg ${className}`}
    >
      <If
        condition={!!icon}
        Then={<img src={icon} alt="" />}
        Else={<Info className={iconClass} style={{ fontSize: 24 }} />}
      />
      <span
        className={`ml-3 text-[12px] text-black leading-5 font-medium ${messageClass}`}
      >
        {message}
      </span>
    </div>
  );
}
